var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Queued Music")]),_vm._v(" "),(_vm.queueList.length > 0)?_c('div',[_c('div',{attrs:{"id":"queue"}},[_c('sortable-playlist',{attrs:{"tracks":_vm.queueList,"sortable":true}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }